export default __webpack_public_path__ + "static/favicon-78fc96f70f34abb4cc7c5546553502bf.ico";